import { Box, Button, Typography, styled } from '@mui/material';

export const StyledTypography = styled(Typography)`
    padding: 1.5rem 1.5rem 0 1.5rem;
` as typeof Typography;

export const ClassFormContainer = styled(Box)`
    width: 635px;
    padding: 0rem;
    margin: 0 auto;
    background-color: ${(props) => props.theme.palette.background.paper};
` as typeof Box;

export const StyledForm = styled('form')`
    display: flex;
    flex-direction: column;
`;

export const StyledFooter = styled(Box)`
    display: flex;
    justify-content: flex-end;
    margin: 0.75rem;
` as typeof Box;

export const StyledButton = styled(Button)`
    margin-left: 0.75rem;
` as typeof Button;
